import { Root } from '@radix-ui/react-slot'
import React from 'react'
import styled from 'styled-components'

import { IconButton } from '../Icon/Icon.styles'

export const DragButton = styled(IconButton)`
  cursor: grab;

  &[data-state='dragging'] {
    cursor: grabbing;
  }
`

interface UnstyledSortableItemProps extends React.HTMLAttributes<HTMLDivElement> {
  asChild?: boolean
  asTrigger?: boolean
  isDragging?: boolean
  className?: string
}

const UnstyledSortableItem = React.forwardRef<HTMLDivElement, UnstyledSortableItemProps>(
  ({ asChild, ...props }, ref) => {
    const Comp = asChild ? Root : 'div'
    return <Comp ref={ref} {...props} />
  }
)

export const StyledSortableItem = styled(UnstyledSortableItem)`
  &[data-state='dragging'] {
    cursor: grabbing;
  }

  ${props =>
    props.asTrigger &&
    !props.isDragging &&
    `
    cursor: grab;
  `}
`
